import React, { Component } from 'react'

class Code extends Component { 
    render() {
        return (
            <div className="code">
                <img height={680} width={500} src="https://i.imgur.com/INk1HLi.png" alt="this is counter code" />
            </div>
        )
    }
}

export default Code 